import { getAddressInfo,  getDefaultAddress } from '@/api/address'
import { preview, previewOneKey } from '@/api/order'

/**
 * 获取订单预览信息
 * @param {Object} context - Vuex 上下文
 * @param {Object} options - 配置参数
 * @param {Array} options.payInfo - 支付信息
 * @param {String} options.payType - 支付类型
 * @param {String} options.addressId - 地址 ID
 * @returns {Promise<Object>} - 订单预览信息
 */

export async function getOrderPreview ({ state }, options = {
  payInfo: state.payInfo,
  payType: state.payType,
  addressId: state.addressId
}) {
  console.log(state.addressId, state.payType, state.payInfo)
  
  if (!state.addressId || !state.payType || !state.payInfo) {
    console.error('请选择支付方式和地址')
    return Promise.reject(new Error('请选择支付方式和地址'))
  }
   if (state.payType === 'cart') {
     return await preview({
       address_id: state.addressId,
       carts_id: `[${state.payInfo}]`
     })
   } else if (state.payType === 'buyNow') {
     return await previewOneKey({
       address_id: state.addressId,
       goods_sn: state.payInfo[0]
     })
  }
  
   return new Error('请选择支付方式和地址')
}

/**
 * 获取默认地址 ID
 * @param {Object} context - Vuex 上下文
 * @returns {Promise<String>} - 默认地址 ID
 */

export async function getDefaultAddressId({ commit }) {
  // try {
    const result = await getDefaultAddress().catch(error => {
      throw error
    })
    const addressInfo = result.data.data.addressInfo
    
    if (Object.keys(addressInfo).length !== 0) {
      commit('SET_ADDRESSID', addressInfo.address_id)
      return addressInfo.address_id
    } else {
      return ''
      // throw new Error('未找到默认地址')
    }
  // } catch (error) {
  //   console.error('获取默认地址失败:', error)
  //   throw error
  // }
}